import React, { useState, useRef, useDeferredValue, useMemo } from 'react';
import * as _ from 'lodash';
import Tippy from '../ReactTippy';

//modals
import { Information, Confirmation } from '../modals/common';

//utilities
import { messageUtility } from '../../utilities/messageUtility';
import { STATUS_CODE } from '../../utilities/constants';
import { useFetchDataWithToken } from '../../utilities/useFetchData';

// service
import DirectApiSettingsApi from '../../services/DirectApiSettings';
import SessionStorageService from '../../services/utilities/SessionStorageService';

// modals
import DirectRegisterBuildeeBotGuideModal from './DirectRegisterBuildeeBotGuideModal';
import { DirectCommunicationErrorModal } from './DirectCommunicationErrorModal';

// icon
import { SuccessCheckCircleIcon } from '../icons/SuccessCheckCircleIcon';
import { FailedCircleIcon } from '../icons/FailedCircleIcon';

export default function DirectRegisterOrganizationExecModal({
  visible,
  setVisible,
  onClose,
}) {
  const [isShowCalcelModal, setIsShowCancelModal] = useState(false);
  const [isShowInuseModal, setIsShowInuseModal] = useState(false);
  const [isShowSubmitErrorModal, setIsShowSubmitErrorModal] = useState(false);
  const [isShowFetchErrorModal, setIsShowFetchErrorModal] = useState(true);
  const [isShowBuildeeBotGuideModal, setIsShowBuildeeBotGuideModal] = useState(
    false
  );

  const fieldId = SessionStorageService.getFieldId();
  const {
    data: organizationData,
    isInitLoded: isOrganizationLoaded,
    isError: isOrganizationError,
  } = useFetchDataWithToken(
    DirectApiSettingsApi.direct_organization_list.fetch_options(fieldId),
    DirectApiSettingsApi.direct_organization_list.fetch_default_response(),
    false,
    true,
    visible
  );
  const directOrganizationList = _.get(
    organizationData,
    'data.entities.direct_organizations',
    []
  );

  const [searchName, setSearchName] = useState('');
  const deferredSearchName = useDeferredValue(searchName);
  const [selectedId, setSelectedId] = useState(null);
  const organizationSelected = !_.isNull(selectedId);
  const [errorMessage, setErrorMessage] = useState(null);
  const isSending = useRef(false);

  const mainModalClose = () => {
    setVisible(false);
    setIsShowCancelModal(true);
  };

  const onSubmit = async selectedId => {
    if (_.isNull(selectedId) || isSending.current) {
      return;
    }
    isSending.current = true;
    try {
      const {
        data,
        result,
        status,
      } = await DirectApiSettingsApi.direct_organization_register(
        fieldId,
        selectedId
      );
      setVisible(false);
      if (!result || status === STATUS_CODE.badRequest) {
        setErrorMessage(_.get(data, 'message', null));
        setIsShowSubmitErrorModal(true);
        return;
      }
      const buildee_bot_registered_flag = _.get(
        data,
        'entities.buildee_bot_registered_flag',
        null
      );
      if (_.isNull(buildee_bot_registered_flag)) {
        setIsShowSubmitErrorModal(true);
        return;
      }
      if (buildee_bot_registered_flag) {
        setIsShowInuseModal(true);
        return;
      } else {
        setIsShowBuildeeBotGuideModal(true);
        return;
      }
    } catch (error) {
      setVisible(false);
      setIsShowSubmitErrorModal(true);
    } finally {
      isSending.current = false;
    }
  };

  return (
    <React.Fragment>
      {!isOrganizationError ? (
        <React.Fragment>
          <Confirmation
            visible={visible}
            rootClassName={'DirectDescriptionModal--RegisterOrganizationExec'}
            title={messageUtility.getMessage('I-001-561')}
            message={
              <React.Fragment>
                {messageUtility.getMessage('I-001-562')}
                <SearchCondition
                  searchName={searchName}
                  setSearchName={setSearchName}
                  setSelectedId={setSelectedId}
                />
                <OrganizationTable
                  directOrganizationData={
                    isOrganizationLoaded ? directOrganizationList : []
                  }
                  searchName={deferredSearchName}
                  selectedId={selectedId}
                  setSelectedId={setSelectedId}
                />
              </React.Fragment>
            }
            confirmButtonText={messageUtility.getMessage('I-000-080')}
            cancelButtonText={messageUtility.getMessage('I-000-017')}
            onConfirm={() => {
              onSubmit(selectedId);
            }}
            onCancel={mainModalClose}
            disabledConfirmButton={!organizationSelected}
            tabFocus={true}
          />
          <DirectRegisterOrganizationCancelModal
            visible={isShowCalcelModal}
            setVisible={setIsShowCancelModal}
            onBack={() => {
              setVisible(true);
            }}
            onClose={onClose}
          />
          <DirectRegisterBuildeeBotGuideModal
            visible={isShowBuildeeBotGuideModal}
            setVisible={setIsShowBuildeeBotGuideModal}
            onClose={onClose}
          />
          <DirectRegisterOrganizationInUseModal
            visible={isShowInuseModal}
            setVisible={setIsShowInuseModal}
            onClose={onClose}
          />
          <DirectRegisterOrganizationErrorModal
            visible={isShowSubmitErrorModal}
            setVisible={setIsShowSubmitErrorModal}
            onClose={onClose}
          />
        </React.Fragment>
      ) : (
        <DirectCommunicationErrorModal
          visible={isShowFetchErrorModal}
          setVisible={setIsShowFetchErrorModal}
          errorMessage={errorMessage}
          closeAction={onClose}
        />
      )}
    </React.Fragment>
  );
}

function DirectRegisterOrganizationCancelModal({
  visible,
  setVisible,
  onBack,
  onClose,
}) {
  return (
    <Confirmation
      visible={visible}
      rootClassName={'DirectDescriptionModal--RegisterOrganizationCancel'}
      title={messageUtility.getMessage('I-001-563')}
      message={messageUtility.getMessage('I-001-564')}
      confirmButtonText={messageUtility.getMessage('I-000-017')}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      onConfirm={() => {
        setVisible(false);
        onClose();
      }}
      onCancel={() => {
        setVisible(false);
        onBack();
      }}
      tabFocus={true}
      isNegative={true}
    />
  );
}

function DirectRegisterOrganizationInUseModal({
  visible,
  setVisible,
  onClose,
}) {
  return (
    <Information
      visible={visible}
      title={
        <React.Fragment>
          <SuccessCheckCircleIcon />
          {messageUtility.getMessage('I-001-565')}
        </React.Fragment>
      }
      message={messageUtility.getMessage('I-001-566')}
      buttonText={messageUtility.getMessage('I-000-248')}
      onClose={() => {
        setVisible(false);
        onClose();
      }}
      tabFocus={true}
      rootClassName={'DirectDescriptionModal--RegisterOrganizationInUse'}
    />
  );
}

function DirectRegisterOrganizationErrorModal({ 
  visible,
  setVisible,
  onClose,
}) {
  return (
    <Information
      visible={visible}
      title={
        <React.Fragment>
          <FailedCircleIcon />
          {messageUtility.getMessage('E-001-454')}
        </React.Fragment>
      }
      message={messageUtility.getMessage('E-001-448')}
      buttonText={messageUtility.getMessage('I-000-017')}
      onClose={() => {
        setVisible(false);
        onClose();
      }}
      rootClassName={'DirectDescriptionModal--RedirectError'}
    />
  );
}

function SearchCondition({ searchName, setSearchName, setSelectedId }) {
  const [isOpen, setOpenStatus] = useState(true);
  const toggleOpen = () => {
    setOpenStatus(prevStatus => !prevStatus);
  };
  const clearSearchCondition = () => {
    if (searchName === '') {
      return;
    }
    setSearchName('');
    setSelectedId(null);
  };

  return (
    <div className='search-panel'>
      <div className='search-panel__header'>
        <div className='search-panel__title'>
          {messageUtility.getMessage('I-000-249')}
        </div>
        <button
          className={isOpen ? 'accordion__btn show' : 'accordion__btn'}
          onClick={toggleOpen}
        />
        <button className='btn-text--sm' onClick={clearSearchCondition}>
          {messageUtility.getMessage('I-000-250')}
        </button>
      </div>
      {isOpen && (
        <div className='search-panel__item'>
          <div className='panel-item form-search'>
            <div className='panel-item__select'>
              <div className='panel-item__select-label'>
                <div className='label'>組織名</div>
              </div>
              <div className='panel-item__select-element'>
                <input
                  className='FormInput'
                  name='fullname'
                  type='text'
                  placeholder='組織名'
                  value={searchName}
                  onChange={e => {
                    setSearchName(e.target.value);
                    setSelectedId(null);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function OrganizationTable({
  directOrganizationData,
  searchName,
  selectedId,
  setSelectedId,
}) {
  return (
    <div className='direct-organization--manage-table'>
      <RenderShowTableHeader />
      <RenderShowTableBody
        data={directOrganizationData}
        searchName={searchName}
        selectedId={selectedId}
        setSelectedId={setSelectedId}
      />
    </div>
  );
}
function RenderShowTableHeader() {
  return (
    <table className='table'>
      <thead className='table__header'>
        <tr className='table__label'>
          <td className='value-table value-table__radio_button'></td>
          <td className='value-table value-table__organization_name'>組織名</td>
          <td className='value-table value-table__after_space' />
        </tr>
      </thead>
    </table>
  );
}

function RenderShowTableBody({ data, searchName, selectedId, setSelectedId }) {
  const renderData = useMemo(() => {
    return _.filter(data, directOrganization => {
      return directOrganization['domain_name'].indexOf(searchName) !== -1;
    });
  }, [data, searchName]);
  return (
    <div className='direct-organization--manage-element'>
      <table className='table'>
        <tbody className='table__body'>
          {_.map(renderData, directOrganization => (
            <RenderShowTableBodyRow
              directOrganization={directOrganization}
              selectedId={selectedId}
              setSelectedId={setSelectedId}
              key={directOrganization['domain_id']}
            />
          ))}
          {_.isEmpty(renderData) && (
            <tr className='table-has-no-data'>
              <td className='table-has-no-data__message'>
                表示できる組織はありません
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

function RenderShowTableBodyRow({
  directOrganization,
  selectedId,
  setSelectedId,
}) {
  return (
    <tr
      className={'table__item'}
      onClick={() => setSelectedId(directOrganization['domain_id'])}
    >
      <td className='value-table value-table__radio_button'>
        <div className='value-table__icon'>
          <label className='checkbox'>
            {/* readOnlyを入れておかないと開発者コンソールで警告が出る */}
            <input
              className='input-radio'
              type='radio'
              checked={selectedId === directOrganization['domain_id']}
              readOnly={true}
            />
          </label>
        </div>
      </td>
      <td className='value-table value-table__organization_name'>
        <RowToolTip
          html={
            <div className='lw-tooltip-content'>
              {directOrganization['domain_name']}
            </div>
          }
        >
          <div className='value-table__text'>
            {directOrganization['domain_name']}
          </div>
        </RowToolTip>
      </td>
    </tr>
  );
}

function RowToolTip({ children, html }) {
  return (
    <Tippy
      duration={10}
      distance={24}
      arrow='true'
      arrowType='sharp'
      delay={[500, 0]}
      placement='bottom'
      followCursor={true}
      html={html}
    >
      {children}
    </Tippy>
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/DirectRegisterOrganizationExecModal.jsx